import React from 'react';
import { useI18n } from '../useI18n.js';

export default function LanguageSwitch({ style }) {
  const { lang, setLang, t } = useI18n();
  const toggle = () => setLang(lang === 'en' ? 'fr' : 'en');
  return (
    <button
      type="button"
      onClick={toggle}
      title={lang === 'en' ? t('switchToFrench') : t('switchToEnglish')}
  style={{ padding: '0.35rem 0.6rem', borderRadius: 0, display: 'inline-flex', alignItems: 'center', gap: '0.35rem', ...style }}
    >
      <span aria-hidden>🌐</span>
      <span>{lang === 'en' ? 'EN' : 'FR'}</span>
    </button>
  );
}
